<template>
    <div class="homepage-exhibits" id="homepage-exhibits">
        <div class="featured row">
            <div class="col-md-12">
                <Event
                    :event="events[0]"
                    full
                ></Event>
            </div>
            <div class="col-md-4"
                v-for="event in events.slice(1,100)"
                :key="event._id"
            >
                <Event
                    :event="event"
                ></Event>
            </div>
        </div>
    </div>
</template>

<script>
import Event from "@/components/Event";

export default {
    name: "Exhibits",
    props: { 
        count: {
            type: Number,
            default: 4,
        }
    },
    async mounted() {
        const that = this
        await this.axios
            .get("https://api.kulturkalender-aachen.de/events?is_ausstellung=1")
            .then(function (response) {
                that.events = response.data.events.slice(0,that.count);
            })
    },
    methods: {
    },
    components: {
        Event: Event,
    },
    computed: {
    },
    updated() {
    },
    data() {
        return {
            events: [],
        };
    }
};
</script>
